import React from "react";
import AuthStackNavigation from "../../routes/authStackNavigator";

import AuthProvider, {
  AuthIsSignedIn,
  AuthIsNotSignedIn,
} from "../../contexts/authContext";
import { IAuthAWS } from "../../interfaces/IAuthAWS";
/* eslint-disable */
import { ITheme } from "../../interfaces/ITheme";
import { IAuthFunctionalities } from "../../interfaces/IAuthFunctionalities";
import { IAuth } from "interfaces/IAuth";

const AuthContext = React.createContext<any>(null)
interface IProps {
  awsConfig: IAuthAWS;
  theme?: undefined;
  authConfig?: IAuthFunctionalities;
}

const AuthModule: React.FC<IProps> = ({
  awsConfig,
  theme,
  authConfig,
  children,
}) => {
  return (
    <AuthProvider
      config={awsConfig}
      authConfig={authConfig}
    >
        <AuthIsSignedIn>{children}</AuthIsSignedIn>
        <AuthIsNotSignedIn>
          <AuthStackNavigation />
        </AuthIsNotSignedIn>
    </AuthProvider>
  );
};

export default AuthModule;
